import {render} from 'react-dom';

import MediaShare from './scenes/MediaShare';
import CampaignPagePreview from '_app/mediashare/scenes/CampaignPagePreview';
import {appConfigService} from '_app/services';
import Provider from 'react-redux/es/components/Provider';
import configureMediaShareStore from './configureMediaShareStore';
import {setBaseURL} from '_app/services/apiService.new';
import './index.less';

import '@emoney/kyber/css/kyber.css';

const store = configureMediaShareStore();

export default (id, appConfig, token) => {
	const AppMediashare = (
		<Provider store={store}>
			{appConfig.campaignPageTemplateId || appConfig.campaignToken ?
				<CampaignPagePreview
					campaignPageTemplateId={appConfig.campaignPageTemplateId}
					isCampaign={appConfig.isCampaign}
					logoUrl={appConfig.logoUrl}
					token={appConfig.campaignToken}
					isPreview={appConfig.isPreview}
					hideDetails={appConfig.hideDetails}
					source={appConfig.source}
					recipientID={appConfig.recipientID}
					emailID={appConfig.emailID}
				/>
				: <MediaShare token={token} />}
		</Provider>
	);
	const element = document.getElementById(id);

	appConfigService.set(appConfig);
	setBaseURL(appConfig.serverPath);

	render(AppMediashare, element);
};